/* import __COLOCATED_TEMPLATE__ from './legend.hbs.js'; */
import FormElementLabel from 'ember-bootstrap/components/bs-form/element/label';
export default class FormElementLegend extends FormElementLabel {}